import { render } from "./DateAndTime.vue?vue&type=template&id=32ab8187&ts=true"
import script from "./DateAndTime.vue?vue&type=script&lang=ts"
export * from "./DateAndTime.vue?vue&type=script&lang=ts"

import "./DateAndTime.vue?vue&type=style&index=0&id=32ab8187&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__